import moment from 'moment';
import { t } from '@lingui/macro';
import { useDispatch } from 'react-redux';
import { isDefined } from '../../../helpers/utils';
import { getTopics } from '../../../containers/course-assign/course-assign-actions';
import { ERROR_DETECTED } from '../../../containers/course-assign/course-assign-types';
import Resources from '../../../helpers/resources';
import { showToast } from '../../toast/toast-action';
import {
  retrieveAssignedTaskId,
  mapSelectedActivitiesToReq
} from '../../../helpers/resources-helper';
import {
  summarizeAssignments,
  useAssignmentFlowTracking
} from '../../../analytics';

const useStatusCellActions = ({
  i18n,
  studentInfo,
  datePreference,
  courseId,
  classroomId,
  groupId,
  onComplete
}) => {
  const dispatch = useDispatch();
  const reassignFlow = useAssignmentFlowTracking('reassign');

  function handleError(err) {
    dispatch({
      type: ERROR_DETECTED,
      payload: err
    });
  }

  function handleSuccess(reassignment) {
    /* eslint-disable indent */
    dispatch(
      showToast(
        i18n._(
          reassignment
            ? t(
                'footer.reassignSuccess'
              )`Selected student activities have been reassigned`
            : t(
                'footer.unassignSuccess'
              )`Selected student activities have been unassigned`
        ),
        'success'
      )
    );
    /* eslint-enable indent */
    dispatch(getTopics(classroomId, groupId));
    onComplete();
  }

  function unassign() {
    Resources.unassign
      .put({ classroomId, groupId })
      .withBody({
        assignedTaskIdList: retrieveAssignedTaskId([studentInfo])
      })
      .send()
      .then(() => handleSuccess(false), handleError);
  }

  function reassign() {
    const startDatePreference = datePreference[0];
    const dueDatePreference = datePreference[1];
    /* eslint-disable indent */
    const startDate = isDefined(startDatePreference)
      ? moment(
          `${startDatePreference[0]} ${startDatePreference[1]}`
        ).toISOString()
      : undefined;
    const dueDate = isDefined(dueDatePreference)
      ? moment(`${dueDatePreference[0]} ${dueDatePreference[1]}`).toISOString()
      : undefined;
    /* eslint-enable indent */
    const requestBody = {
      courseId,
      startDate,
      dueDate,
      hasDueDate: dueDatePreference !== undefined,
      ...mapSelectedActivitiesToReq([studentInfo])
    };

    reassignFlow.start({
      target: 'student',
      dueDate: requestBody.dueDate,
      ...summarizeAssignments([studentInfo])
    });

    Resources.assign
      .post({ classroomId, groupId })
      .withBody(requestBody)
      .send()
      .then(() => {
        reassignFlow.confirm({
          target: 'student',
          ...summarizeAssignments([studentInfo])
        });
        handleSuccess(true);
      }, handleError);
  }

  return { unassign, reassign };
};

export default useStatusCellActions;



// WEBPACK FOOTER //
// ./components/status-cell/hooks/use-status-cell-actions.js